"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsClientSyncProvider = exports.useDataBucketSync = void 0;
const react_1 = __importDefault(require("react"));
const setup_ws_client_sync_1 = require("./internal/setup-ws-client-sync");
const use_connection_status_1 = require("./internal/use-connection-status");
const WsClientSyncContext = react_1.default.createContext({});
function useDataBucketSync() {
    return react_1.default.useContext(WsClientSyncContext);
}
exports.useDataBucketSync = useDataBucketSync;
function WsClientSyncProvider(props) {
    const wsClientSyncRef = react_1.default.useRef();
    const [dataBucketStateByVarName, setDataBucketStateByVarName] = react_1.default.useState({});
    const [dataBucketTopicInfoByVarName, setDataBucketTopicInfoByVarName] = react_1.default.useState({});
    const connection = use_connection_status_1.useConnectionStatus_(wsClientSyncRef.current);
    react_1.default.useEffect(() => {
        if (!wsClientSyncRef.current) {
            const { fetchConnectionInstructions, wsClientSyncOpts } = props;
            wsClientSyncRef.current = setup_ws_client_sync_1.setupWsClientSync({
                fetchConnectionInstructions,
                wsClientSyncOpts,
                setDataBucketStateByVarName,
                setDataBucketTopicInfoByVarName,
            });
        }
    }, []);
    let value;
    value = {
        connection,
        dataBucketStateByVarName,
        dataBucketTopicInfoByVarName,
        wsClientSync: wsClientSyncRef.current,
    };
    return react_1.default.createElement(WsClientSyncContext.Provider, { value: value }, props.children);
}
exports.WsClientSyncProvider = WsClientSyncProvider;
//# sourceMappingURL=WsClientSyncProvider.js.map